export default {
  increment(v) {
    v.dispatch("decrement", 2);
  },
  decrement(v, params) {
    v.commit("mini", params);
  },
  changeSchemaId({ commit }, params) {
    commit("changeSchemaId", params);
  },
  session({ commit }, params) {
    commit("session", params);
  },
  meetingInfo({ commit }, params) {
    commit("meetingInfo", params);
  },
  templateInfo({ commit }, params) {
    commit("templateInfo", params);
  }
};
